<template>
    <div class="form-container" style="max-width: none;">
        <h2>Obstetrical History</h2>
        <hr />

        <div v-if="loading" class="loading-overlay">
            <div class="spinner"></div>
        </div>
        <div v-else-if="errorMessage" class="error-message">{{ errorMessage }}</div>

        <form @submit.prevent="submitForm" v-else>
            <div class="form-check mb-2">
                <input class="form-check-input" type="checkbox" v-model="form.pregnant" />
                <label class="form-check-label">Pregnant</label>
            </div>

            <div class="form-check mb-2">
                <input class="form-check-input" type="checkbox" v-model="form.ever_pregnant" />
                <label class="form-check-label">Ever Pregnant</label>
            </div>

            <label>Pregnancy Count</label>
            <input type="number" class="form-control mb-1" v-model="form.pregnancy_count" />
            <div class="text-danger" v-if="errors.pregnancy_count">{{ errors.pregnancy_count[0] }}</div>

            <label>Contraceptive Type</label>
            <input type="text" class="form-control mb-1" v-model="form.contraceptive_type" />
            <div class="text-danger" v-if="errors.contraceptive_type">{{ errors.contraceptive_type[0] }}</div>

            <div class="form-check mb-2">
                <input class="form-check-input" type="checkbox" v-model="form.regular_cycle" />
                <label class="form-check-label">Regular Cycle</label>
            </div>

            <div class="form-check mb-2">
                <input class="form-check-input" type="checkbox" v-model="form.cramping" />
                <label class="form-check-label">Cramping</label>
            </div>

            <label>Comments</label>
            <textarea class="form-control mb-1" v-model="form.comments"></textarea>
            <div class="text-danger" v-if="errors.comments">{{ errors.comments[0] }}</div>

            <div class="form-check mb-2">
                <input class="form-check-input" type="checkbox" v-model="form.pap_smear" />
                <label class="form-check-label">Pap Smear</label>
            </div>

            <label>Pap Smear When</label>
            <input type="text" class="form-control mb-1" v-model="form.pap_smear_when" />
            <div class="text-danger" v-if="errors.pap_smear_when">{{ errors.pap_smear_when[0] }}</div>

            <div class="d-flex justify-content-end mt-3">
                <button class="btn btn-sm btn-primary" type="submit" :disabled="submitting">
                    {{ isEditing ? 'Update' : 'Save' }}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    props: {
        iop_medical_print_id: Number,
    },
    data() {
        return {
            loading: true,
            submitting: false,
            errorMessage: '',
            errors: {},
            isEditing: false,
            form: {
                iop_medical_print_id: this.iop_medical_print_id,
                pregnant: false,
                ever_pregnant: false,
                pregnancy_count: '',
                contraceptive_type: '',
                regular_cycle: false,
                cramping: false,
                comments: '',
                pap_smear: false,
                pap_smear_when: '',
            },
        };
    },
    async created() {
        try {
            const response = await this.$api.get(`/iop-obstetrical-histories/${this.iop_medical_print_id}`);
            if (response.data) {
                this.form = { ...response.data };
                this.isEditing = true;
                this.form.iop_medical_print_id = this.iop_medical_print_id;
                this.dataId = response.data.id;
            }
        } catch (error) {
            if (error.response && error.response.status !== 404) {
                this.errorMessage = error.response?.data?.message || 'Failed to load data';
            }
        } finally {
            this.loading = false;
        }
    },
    methods: {
        async submitForm() {
            this.submitting = true;
            this.errors = {};
            try {

                await this.$api.post('/iop-obstetrical-histories', {
                    ...this.form,
                });

                this.$router.back();
            } catch (error) {
                if (error.response?.status === 422) {
                    this.errors = error.response.data.errors || {};
                } else {
                    this.errorMessage = error.response?.data?.message || 'Something went wrong';
                }
            } finally {
                this.submitting = false;
            }
        },
    },
};
</script>